<template>
    <div>
        <limitless-page-header></limitless-page-header>

        <div class="content">

            <rednax-datatable ref="statustable" :url="'/vue/jobs/status'" :columns="table_columns" :filter="table_filter" @updateFilter="table_filter=$event" @rowclick="rowClick" history sort-by="id" sort-order="desc"></rednax-datatable>

            <div id="modal_job" class="modal fade">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Job</h5>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div v-if="job" class="modal-body">
                            <div class="form-group">
                                <h6>Logg:</h6>
                                <div class="card card-body">
                                    <div v-for="(message, m_idx) in job.output.log" :key="'log-' + m_idx">
                                        <div :class="getClass(message.type)">
                                            {{ message.date }}: {{ message.message }}
                                            <a v-if="message.link" :href="message.link">{{ message.link }}</a>
                                            <a v-else-if="message.data && message.data.link" :href="message.data.link">{{ message.data.link }}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <h6>Input:</h6>
                                <pre v-html="job.input"></pre>
                            </div>
                        </div>
                        <div v-else class="modal-body">
                            <i style="color:red;">Kunde ej ladda data</i>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-light" data-dismiss="modal">Stäng</button>
                        </div>
                    </div>
                </div>
            </div> <!-- /modal -->

        </div> <!-- /content -->
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';

export default {
    components: {
        LimitlessPageHeader,
        RednaxDatatable,
    },
    data: () => ({
        job: null,
        interval: null,
        table_filter: {
            search: '',
        },
        table_columns: [
            {
                header: '#',
                data: 'id',
                sortable: true,
            },
            {
                header: 'Typ',
                data: 'type',
                sortable: true,
                render(row) {
                    const parts = row.type.split('\\');
                    const answer = parts[parts.length - 1];
                    return answer;
                },
            },
            {
                header: 'Status',
                data: 'status',
                sortable: true,
                render(row) {
                    let html = '';
                    if (row.status === 'finished') {
                        html = '<div>';
                        html += '<div class="badge badge-success">Klar</div>';
                        if (row.output.log_has_errors) {
                            html += '<i class="icon-warning22 text-danger ml-2"></i>';
                        }
                        if (row.output.log_has_warnings) {
                            html += '<i class="icon-warning text-warning ml-2"></i>';
                        }
                        html += '</div>';
                    } else if (row.status === 'queued') {
                        html = '<div class="badge badge-info">Ligger i kö</div>';
                    } else if (row.status === 'failed') {
                        html = '<div class="badge badge-danger">Misslyckades</div>';
                    } else if (row.status === 'executing') {
                        html = '<div class="badge badge-warning">Pågår</div>';
                    } else {
                        html = '<div class="badge badge-warning">' + row.status + '</div>';
                    }
                    return html;
                },
            },
            {
                header: 'Message',
                data: 'output',
                sortable: false,
                render(row) {
                    return (row.output && row.output.message ? row.output.message : '');
                },
            },
            {
                header: 'Progress',
                data: 'progress_now',
                sortable: true,
                render(row) {
                    return ((row.progress_now / row.progress_max) * 100).toFixed(1) + '%';
                },
            },
            {
                header: 'Försök',
                data: 'attempts',
                sortable: true,
            },
            {
                header: 'Skapad',
                data: 'created_at',
                sortable: true,
            },
            {
                header: 'Startad',
                data: 'started_at',
                sortable: true,
            },
            {
                header: 'Klar',
                data: 'finished_at',
                sortable: true,
            },
        ],
    }),
    mounted() {
        this.interval = setInterval(() => {
            this.$refs.statustable.get_data();
        }, 10000);
    },
    beforeDestroy() {
        this.clearTimer();
    },
    methods: {
        rowClick(data) {
            this.job = data;
            $('#modal_job').modal('show');
        },
        clearTimer() {
            clearInterval(this.interval);
        },
        getClass(type) {
            if (type === 'error' || type === 'critical') {
                return 'text-danger';
            }
            if (type === 'warning') {
                return 'text-warning';
            }
            if (type === 'info') {
                return 'text-info';
            }
            return '';
        },
    },
};

</script>
